import { getMenuList } from 'graphql/queries/getHeader';

import { useGraphqlQuery } from '@/hooks/useGraphqlQuery';
import { extractNavMenu } from '@/lib/utils';

export const useInternalMenuData = () => {
  const {
    data: internalMenuData,
    error: internalMenuError,
    loading: isInternalMenuLoading,
  } = useGraphqlQuery(false, '', getMenuList, true, 'INTERNAL_MENU');

  const menuSections = internalMenuData?.NBJMenuList?.[0]?.menuSections ?? [];
  const internalMenu = extractNavMenu(menuSections);

  return { internalMenu, internalMenuError, isInternalMenuLoading };
};
